
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-graph-coordinate-demo-api-graph-coord"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.en.md?type=demo')
};